import { iconDefinitions } from './caviar/icon/icon-semantics.js';
import { iconDefinitions as iconDefinitions$1 } from './default/icon/icon-semantics.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var currentIconSubdirectoryName = '2022-11-21T01:22:17.159Z';
var availableCaviarTypes = {};
var availableCaviarAssets = {};
iconDefinitions.forEach(function (iconDefinition) {
  availableCaviarTypes[iconDefinition.name] = iconDefinition.name;
  iconDefinition.sizes.forEach(function (iconSize) {
    availableCaviarAssets["".concat(iconSize).concat(iconDefinition.name)] = "".concat(iconSize, "/").concat(iconDefinition.fileName, ".svg");
  });
});
var availableDefaultTypes = {};
var availableDefaultAssets = {};
iconDefinitions$1.forEach(function (iconDefinition) {
  availableDefaultTypes[iconDefinition.name] = iconDefinition.name;
  iconDefinition.sizes.forEach(function (iconSize) {
    availableDefaultAssets["".concat(iconSize).concat(iconDefinition.name)] = "".concat(iconSize, "/").concat(iconDefinition.fileName, ".svg");
  });
});
var availableTypes = {
  Caviar: _objectSpread({}, availableCaviarTypes),
  DoorDash: _objectSpread({}, availableDefaultTypes)
};
var caviarIcons = availableCaviarAssets;
var doordashIcons = availableDefaultAssets;

export { availableTypes, caviarIcons, currentIconSubdirectoryName, doordashIcons };
